import HourlySecond from "./HourlySecond";

export default HourlySecond;